export default __webpack_public_path__ + "static/media/ACF.6971b921.png";